<template>
  <FomoButton class="download-primary receipt-download-action" variant="primary" icon="" :disabled="disabled" :aria-label="actionLabel">
    <span class="download-label">
      <ReceiptIcon name="download" />
      <span class="download-label__copy">
        <span class="download-label__full" :class="{ 'has-compact-label': isTicketDownload, 'is-status-label': !isTicketDownload }">{{ actionLabel }}</span>
        <span v-if="isTicketDownload" class="download-label__compact">Descargar</span>
        <small v-if="isTicketDownload" class="download-label__meta">{{ count ? `${count} ${count === 1 ? 'entrada' : 'entradas'}` : 'Tus entradas' }} · PDF</small>
      </span>
    </span>
  </FomoButton>
</template>

<script>
import FomoButton from '../ui/FomoButton.vue'
import ReceiptIcon from './ReceiptIcon.vue'

export default {
  name: 'ReceiptDownloadButton',
  components: { FomoButton, ReceiptIcon },
  props: {
    label: { type: String, default: 'Descargar entradas' },
    count: { type: Number, default: 0 },
    ready: Boolean,
    disabled: Boolean,
  },
  computed: {
    isTicketDownload() { return this.ready && !this.disabled && this.label === 'Descargar entradas' },
    actionLabel() { return this.isTicketDownload && this.count ? `Descargar ${this.count} ${this.count === 1 ? 'entrada' : 'entradas'}` : this.label },
  },
}
</script>
